// extracted by mini-css-extract-plugin
module.exports = {"StoryContestDecoration":"StoryContestDecoration-module--StoryContestDecoration--115gI"};